import { render, staticRenderFns } from "./FscCard.vue?vue&type=template&id=d765e352"
import script from "./FscCard.vue?vue&type=script&lang=ts"
export * from "./FscCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports